var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecklistClipboardOlive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.281.82A2.059 2.059 0 008.641 0C7.993 0 7.385.31 7 .82H5.77v.82H4.129V2l-2.15 8.629c-.13.52-.595.883-1.131.883v.82h3.28V14h9.024V1.64h-1.64V.82h-1.23zM4.13 11.512H2.456c.146-.201.255-.432.319-.685l1.354-5.434v6.119zm2.46-9.871h.867c.047-.052.331-.82 1.185-.82.85 0 1.14.771 1.184.82h.866v.82H6.59v-.82zm5.743.82V13.18H4.949V2.46h.82v.821h5.743v-.82h.82z",
    fill: "#767F6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.6l-.53-.53-.58.58L7 6.76l1.93-1.93-.58-.581L7 5.599zM7 8.06l-.53-.53-.58.58L7 9.22l1.93-1.93-.58-.58L7 8.06zM7 10.521l-.53-.53-.58.58L7 11.681l1.93-1.93-.58-.58L7 10.52zM9.871 5.77h1.64v.82h-1.64v-.82zM9.871 8.23h1.64v.82h-1.64v-.82zM9.871 10.691h1.64v.82h-1.64v-.82z",
    fill: "#767F6A"
  })));
}

export default SvgChecklistClipboardOlive;